import { Card, CardBody } from "@heroui/react";
import { formatDate } from "date-fns";

import { useCountdown } from "../../hooks/useCountdown";
import { EVENT_NAME } from ".";
import { useEventDates } from "./useEventDates";

export const EventDatesCard = () => {
  const { state, start, end } = useEventDates();

  if (state === "UNKNOWN")
    return <>{import.meta.env.DEV && "Dev: event.dates is not set"}</>;

  switch (state) {
    case "BEFORE":
      return <BeforeEvent start={start!} />;
    case "DURING":
      return <DuringEvent end={end!} />;
    case "AFTER":
      return <AfterEvent start={start!} end={end!} />;
  }

  return (
    <Card className="canvas-overlay-card">
      <CardBody>{state}</CardBody>
    </Card>
  );
};

const BeforeEvent = ({ start }: { start: number }) => {
  const { timeLeft } = useCountdown(start);

  return (
    <Card className="canvas-overlay-card">
      <CardBody>
        <h2 className="text-2xl font-bold text-center w-full">{EVENT_NAME}</h2>
        <h3 className="text-large text-center w-full">
          Starts in <span className="font-semibold">{timeLeft}</span>
        </h3>
      </CardBody>
    </Card>
  );
};

const DuringEvent = ({ end }: { end: number }) => {
  const { timeLeft } = useCountdown(end);

  return (
    <Card className="canvas-overlay-card">
      <CardBody>
        <h2 className="text-2xl font-bold text-center w-full">{EVENT_NAME}</h2>
        <h3 className="text-large text-center w-full">
          Ends in <span className="font-semibold">{timeLeft}</span>
        </h3>
      </CardBody>
    </Card>
  );
};

const AfterEvent = ({ start, end }: { start: number; end: number }) => {
  return (
    <Card className="canvas-overlay-card">
      <CardBody>
        <h2 className="text-2xl font-bold text-center w-full">{EVENT_NAME}</h2>
        <h3 className="text-large text-center w-full">
          <strong>
            {formatDate(start, "MMM do @ h:mm a")} -{" "}
            {formatDate(end, "MMM do @ h:mm a")}
          </strong>
        </h3>
      </CardBody>
    </Card>
  );
};
